/**
 * Internal dependencies
 */
 import CustomWelcomeGuide from './components/CustomWelcomeGuide';
 import icons from "../../icons.js";
 /**
	* WordPress dependencies
	*/
 import { useDispatch, useSelect } from '@wordpress/data';
 import { registerPlugin } from '@wordpress/plugins';
 import { Fragment } from '@wordpress/element';
 import { PluginMoreMenuItem } from '@wordpress/edit-post';


 const CustomWelcomeGuidePlugin = () => {
	 const { toggleFeature } = useDispatch( 'core/edit-post' );
	 const isActive = useSelect( ( select ) => select( 'core/edit-post' ).isFeatureActive( 'customWelcomeGuide' ), [] );
 
	 return (
		 <Fragment>
			 <PluginMoreMenuItem
				 icon={icons.base}
				 onClick={ () => {
					 toggleFeature( 'customWelcomeGuide' );
				 } }
			 >
				 Guide des blocs WP-Apidae
			 </PluginMoreMenuItem>
 
			 { isActive && (
				 <CustomWelcomeGuide />
			 ) }
		 </Fragment>
	 );
 };
 
 registerPlugin( 'custom-edit-post', {
		icon: icons.base,
	 render: CustomWelcomeGuidePlugin,
 } );